
import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { sha3_512 } from 'js-sha3';
import { getItem } from '../utils/localStore';

class verifyPasswordApi {
    static doVerifyPassword(data) {
        const TOKEN = getItem('auth_token');
        let sendBody={
            encrypted_password:sha3_512(data.current_password)
        }
        let isError = false;

        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(sendBody)
            }
            return fetch(BASE_URL + '/users/password/verify', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default verifyPasswordApi;
